<template>
  <div :id="canvasId" style="height: 100%; width: 100%" />
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import HighchartsMixin from "@/mixins/Highcharts.js";
import Highcharts from "highcharts";

export default {
  name: "",
  props: ["value", "canvasId"],
  mixins: [HighchartsMixin],
  components: {},
  data() {
    return {
      data: [],
      chart: null,
      isLoading: false,

      terpeneTests: [],
      filteredTerpeneTests: [],
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },

  beforeMount() {
    this.refresh();
  },

  watch: {
    value(newVal) {
      this.refresh();
    },
  },

  methods: {
    plotTerpenes(categories, series) {
      let me = this;

      if (this.chart) {
        this.chart.destroy();
      }

      if (!document.getElementById(this.canvasId)) {
        setTimeout(function () {
          me.plotTerpenes(categories, series);
        }, 50);
        return;
      }

      this.chart = Highcharts.chart(this.canvasId, {
        chart: {
          type: "bar",
          styledMode: true,
        },

        credits: {
          enabled: false,
        },

        exporting: false,

        title: {
          text: null,
        },

        legend: {
          reversed: true,
        },

        plotOptions: {
          series: {
            stacking: "normal",
          },
        },

        xAxis: {
          categories: categories,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total Percentage",
          },
        },

        series: series,
      });
    },

    refresh: async function () {
      let me = this;

      let res = this.value;

      let group = {};
      let testNames = Object.keys(this.value[0].tests).sort().reverse();

      let cats = this.value.map(
        (a) => a.ProductName + "-" + a.TestPerformedDate.split("T")[0]
      );

      let series = [];
      for (let i = 0; i < testNames.length; i++) {
        let rec = {
          name: testNames[i],
          data: [],
        };
        for (let j = 0; j < this.value.length; j++) {
          let val = this.value[j].tests[testNames[i]];
          if (!val) {
            val = 0;
          }
          rec.data.push(val);
        }
        series.push(rec);
      }

      me.plotTerpenes(cats, series);
    },
  },
};
</script>

<style lang="scss">
</style>
